import React from 'react';

type SilverCapableUser = {
  role?: string;
  subscription_tier?: string;
} | null | undefined;

const SilverBadge: React.FC<{ user?: SilverCapableUser }> = ({ user }) => {
  if (!user) return null;
  const role = user.role || '';
  if (!['candidate', 'recruiter'].includes(role)) return null;
  if (user.subscription_tier !== 'silver') return null;

  return <span className="badge silver-badge">Silver</span>;
};

export default SilverBadge;
